import { createSlice } from '@reduxjs/toolkit';

import type { ISimilarBuilding } from 'shared/types/similarBuildings';

/** Данные приходят только из SSR (preloadedState), экшенов нет */
const similarBuildingsSlice = createSlice({
  initialState: [] as ISimilarBuilding[],
  name: 'similarBuildings',
  reducers: {},
});

export const { reducer: similarBuildingsReducer } = similarBuildingsSlice;
